<script lang="ts">
  import { clientPublicStore, fn } from "../../../stores";
  import { get } from "svelte/store";

  const { close, logout } = get(fn);

  const ui = $derived($clientPublicStore?.ui_settings);
  const title = $derived(ui?.welcome_title);
  const description = $derived(ui?.welcome_text);
  const textStyle = $derived(ui?.text_color ? `color:${ui.text_color} !important` : undefined);
  const btnStyle = $derived(
    ui?.primary_color
      ? `background-color:${ui.primary_color} !important;border-color:${ui.primary_color} !important`
      : undefined,
  );

  const btnClass = `crtw-px-[36px] crtw-flex crtw-justify-center crtw-items-center crtw-bg-black crtw-text-white crtw-h-[50px] crtw-cursor-pointer
      crtw-border-0 crtw-rounded crtw-font-['Poppins'] crtw-text-sm crtw-font-medium`;
</script>

<div class="crtw-flex crtw-flex-col crtw-justify-start crtw-items-start crtw-w-full crtw-mx-[50px]">
  <div class="crtw-flex crtw-flex-col crtw-justify-start crtw-items-start crtw-font-['Poppins'] crtw-w-full">
    <span class="crtw-text-[24px] crtw-text-[#313a2c] crtw-font-medium" style={textStyle}>
      {title}
    </span>

    <span class="crtw-text-base crtw-text-[#747474] crtw-mb-1" style={textStyle}>
      {description}
    </span>
  </div>

  <div class="crtw-flex crtw-flex crtw-gap-[6px] crtw-w-full crtw-items-center crtw-mb-[100px] crtw-mt-[30px]">
    <button class={btnClass} style={btnStyle} onclick={() => logout()}>Cancel</button>
    <button class={btnClass} style={btnStyle} onclick={() => close()}>OK</button>
  </div>
</div>
